import { technology } from "../../constants";
import styles, { layout } from "../../style";
import { Link } from 'react-router-dom';

const FeatureCard = ({ icon, title, content, index }) => (
  <div className="p-6 rounded-2xl bg-white border-2 border-gray-100 hover:border-gray-300 hover:shadow-lg transition-all duration-300">
    {/* Icon */}
    <div className="mb-4 inline-flex h-14 w-14 items-center justify-center rounded-xl bg-gradient-to-br from-blue-100 to-emerald-100">
      <img src={icon} alt={title} className="w-7 h-7 object-contain" />
    </div>
    
    {/* Content */}
    <h4 className="mb-2 text-xl font-bold text-gray-900">
      {title}
    </h4>
    <p className="text-sm leading-relaxed text-gray-600">
      {content}
    </p>
  </div>
);

const TechnologyPreview = () => (
  <section id="technology" className="py-20 bg-gradient-to-b from-gray-50 to-white">
    <div className="container mx-auto px-4">
      
      {/* Section Header */}
      <div className="text-center mb-16">
        <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-blue-50 px-4 py-2">
          <span className="h-2 w-2 rounded-full bg-blue-500 animate-pulse"></span>
          <span className="text-sm font-medium text-blue-700">Our Technology</span>
        </div>
        
        <h2 className="mb-6 text-4xl font-bold text-gray-900 md:text-5xl">
          AI Solutions for
          <span className="block mt-2 bg-gradient-to-r from-blue-600 to-emerald-600 bg-clip-text text-transparent">
            Street Infrastructure Management
          </span>
        </h2>
        
        <p className="mx-auto max-w-2xl text-lg text-gray-600">
          Our AI-powered platform helps cities digitize, analyze, and optimize their entire street infrastructure
        </p>
      </div>

      {/* Technology Cards Grid */}
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4 mb-12">
        {technology.map((feature, index) => (
          <FeatureCard key={feature.id} {...feature} index={index} />
        ))}
      </div>

      {/* CTA Button */}
      <div className="text-center">
        <Link to='/technology'>
          <button className="group relative overflow-hidden rounded-full bg-gradient-to-r from-blue-600 to-emerald-600 px-8 py-4 font-semibold text-white shadow-lg transition-all hover:shadow-xl hover:scale-105">
            <span className="relative z-10 flex items-center gap-2">
              Learn More About Our Technology
              <svg className="w-5 h-5 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </span>
            <div className="absolute inset-0 -translate-x-full bg-white/20 transition-transform group-hover:translate-x-0"></div>
          </button>
        </Link>
      </div>
    </div>
  </section>
);

export default TechnologyPreview;